<template>
  <div>
    <h2>所有工具</h2>

    <div class="container mx-auto px-4 py-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3">
      <ToolCard v-for="tool in tools" :key="tool.id" :title="tool.title" :to="tool.to" :icon="tool.icon"
        :toolId="tool.id" :description="tool.description" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import ToolCard from '../components/ToolCard.vue'
import toolsData from '../assets/tools.json'

// 1. 定義資料結構
interface Tool {
  id: string
  title: string
  to: string      // 根據上一題，這可能是選填的
  icon: string
  description: string
}

// 2. 在 ref 後面加上 <Tool[]> 告訴 TS 這是什麼陣列
const tools = ref<Tool[]>([])

onMounted(() => {
  tools.value = toolsData
})
</script>
